import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { identity } from 'lodash'

import FilterBarContext from '../context'

const ShowMore = ({ onChange, allShown }) => {
  const { t } = useContext(FilterBarContext)

  return (
    <Link className='link-layout' href='#' onClick={onChange} to=''>
      {allShown ? t('COLLAPSE_ALL') : t('SHOW_MORE')}
    </Link>
  )
}

ShowMore.propTypes = {
  onChange: PropTypes.func,
  allShown: PropTypes.bool
}

ShowMore.defaultProps = {
  onChange: identity,
  allShown: true
}

export default React.memo(ShowMore)
